import { calculateDuration, getCurrentISOString } from '@/lib/dates'
import { getDeviceLocation } from '@/lib/device-location'
import { captureException } from '@/lib/errors'
import { log } from '@/lib/logger'
import { useMutation } from '@/lib/mutations'
import { offlineExecutor } from '@/lib/offline'
import { useStore } from '@/lib/pocketbase'

interface ClockOutData {
    entryId: string
    clockIn: string
}

export function useClockOut() {
    const [timeEntriesCollection] = useStore('time_entries')

    const mutation = useMutation({
        networkMode: 'always',
        mutationFn: async (data: ClockOutData) => {
            const clockOutTime = getCurrentISOString()

            const durationSeconds = calculateDuration({
                clock_in: data.clockIn,
                clock_out: clockOutTime,
            })

            const tx = offlineExecutor.createOfflineTransaction({
                mutationFnName: 'syncTimeEntries',
            })
            tx.mutate(() => {
                timeEntriesCollection.update(data.entryId, draft => {
                    draft.clock_out = clockOutTime
                    draft.status = 'pending'
                    draft.duration = durationSeconds
                })
            })

            getDeviceLocation()
                .then(location => {
                    if (!location) return
                    const locationTx = offlineExecutor.createOfflineTransaction({
                        mutationFnName: 'syncTimeEntries',
                    })
                    locationTx.mutate(() => {
                        timeEntriesCollection.update(data.entryId, draft => {
                            draft.clock_out_location = location
                        })
                    })
                    log.debug('Clock-out location captured', location)
                })
                .catch(() => {})
        },
        onError: error => {
            captureException('Clock out failed', error)
        },
    })

    return {
        mutate: mutation.mutate,
        mutateAsync: mutation.mutateAsync,
        isPending: mutation.isPending,
    }
}
